import { UpdateOrganizationRequestType } from "@interfaces/organization.type";

import { tsRestClient } from "./tsRest";

export const getOrganization = async (organizationId: string) => {
  const { body, status } = await tsRestClient.organizations.getOrganizationById({
    params: { organizationId: organizationId },
  });
  if (status !== 200) {
    throw new Error("Failed to get organization details");
  }
  return body;
};

export const updateOrganization = async (organizationId: string, updateOrganization: UpdateOrganizationRequestType) => {
  const { body, status } = await tsRestClient.organizations.updateOrganization({
    body: updateOrganization,
    params: { organizationId: organizationId },
  });
  if (status !== 200) {
    throw new Error("Failed to get organization details");
  }
  return body;
};

export const updateOrganizationChatModel = async (organizationId: string, chatModel: string) => {
  const { body, status } = await tsRestClient.organizations.updateOrganization({
    body: { chatModel: chatModel },
    params: { organizationId: organizationId },
  });
  if (status !== 200) {
    throw new Error("Failed to update organization chat model");
  }
  return body;
};

export const archiveOrganizationUser = async (userId: string): Promise<void> => {
  const { status } = await tsRestClient.organizations.archiveOrganizationUser({
    body: { userId: userId },
  });
  if (status !== 200) {
    throw new Error("Failed to delete user");
  }
};

export const listTechnologies = async (organizationId: string) => {
  const { body, status } = await tsRestClient.organizations.getOrganizationTechnologies({
    params: { organizationId: organizationId },
  });
  if (status !== 200) {
    throw new Error("Failed to get organization technologies");
  }
  return body;
};

export const listUsers = async (organizationId: string) => {
  const { body, status } = await tsRestClient.organizations.getOrganizationUsers({
    params: { organizationId: organizationId },
  });
  if (status !== 200) {
    throw new Error("Failed to get organization users");
  }
  return body;
};

export const assignUsersToTechnology = async (userIds: string[], technologyId: string) => {
  const { body, status } = await tsRestClient.organizations.addAssigneesToTechnology({
    body: { technologyId: technologyId, userIds: userIds },
  });
  if (status !== 200) {
    throw new Error("Failed to assign users to technology");
  }
  return body;
};
